import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { addUser, editUser, getRoleList, getOrgList, enableUsers, disableUsers } from '../../../api/user';
import { EventBus } from '@blade/common';
import langMsg from '@blade-sxp/account/pages/account/lang/index';
import { LoginModule } from '@blade/common/store/login';
import { mapTree } from '@blade-sxp/account/utils/orgnization-map-tree';
import { OrganizationModule } from '@blade-sxp/account/store/organization';
import treeSelect from '@blade-sxp/account/components/tree-select.vue';
import deviceSelect from '@blade/common/components/device-group-cascader-select/index.vue';
let default_1 = class default_1 extends Vue {
    addDialogVisible;
    type;
    roleOptions = [];
    departmentOptions = [];
    switchValue = false;
    treeData = [];
    value = '';
    formData = {
        real_name: '',
        user_name: '',
        role_id: '',
        org_id: '',
        phone: '',
        email: '',
        password: '',
        check_password: '',
        assign_devices: [],
        shared: true,
    };
    validatePass = (rule, value, callback) => {
        let regex = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$');
        this.formData.password = value;
        this.$refs.ruleForm.validateField('check_password');
        if (value === '') {
            callback(new Error(this.$t('selectPassword')));
        }
        else if (!regex.test(value)) {
            callback(new Error(this.$t('charType')));
        }
        else {
            if (this.formData.check_password !== '') {
                this.$refs.ruleForm.validateField('check_password');
            }
            callback();
        }
    };
    validateCheckPass = (rule, value, callback) => {
        if (this.$parent.type !== 'detail') {
            if (value === '') {
                callback(new Error(this.$t('againPassword')));
            }
            else if (value !== this.formData.password) {
                callback(new Error(this.$t('InconsistentPasswords')));
            }
            else {
                callback();
            }
        }
    };
    // formData rules
    get rules() {
        return {
            user_name: [{ required: this.$parent.type !== 'detail', message: this.$t('selectAccount'), trigger: 'change' }],
            real_name: [{ required: this.$parent.type !== 'detail', message: this.$t('selectName'), trigger: 'change' }],
            role_id: [
                { required: this.$parent.type !== 'detail' && !this.formData.shared, message: this.$t('selectRole'), trigger: 'change' },
            ],
            org_id: [{ required: this.$parent.type !== 'detail', message: this.$t('selectdepartment'), trigger: 'change' }],
            password: [{ required: true, validator: this.validatePass, trigger: 'change' }],
            check_password: [{ required: true, validator: this.validateCheckPass, trigger: 'change' }],
            phone: [
                {
                    required: false,
                    validator: (rule, value, callback) => {
                        if (this.formData.phone && this.formData.phone.length && this.formData.phone.length < 3) {
                            callback(new Error(this.$t('phoneLengthError').toString()));
                        }
                        else {
                            callback();
                        }
                    },
                    trigger: 'change',
                },
            ],
        };
    }
    get init() {
        return LoginModule.privacyMode;
    }
    handleClose() {
        this.$emit('update:addDialogVisible', false);
    }
    // 获取角色枚举
    getRoleList() {
        getRoleList().then((res) => {
            this.roleOptions = res;
        });
    }
    // 角色变化
    changeRole() {
        this.$forceUpdate();
    }
    // 选择部门
    handleUpdateDep(data) {
        this.formData.org_id = data.id;
    }
    // 获取部门枚举
    getOrgList() {
        getOrgList({ size: 100 }).then((res) => {
            this.departmentOptions = res.org_vos;
        });
    }
    async getOrganization() {
        try {
            const res = await OrganizationModule.getOrganizationTree();
            this.treeData = mapTree([res]);
        }
        catch (e) { }
    }
    mounted() {
        this.getOrganization();
        this.getRoleList();
        EventBus.$on('getuserDetail', (data) => {
            this.getOrganization();
            this.getOrgList();
            if (data) {
                data.role_id = data.role_ids[0];
                if (this.init) {
                    data.email = data.email.replace(/(?<=.{1})[^@]+(?=@)/, '*****');
                    if (this.$parent.type === 'detail' && data.phone) {
                        data.phone = data.phone?.substring(0, 3) + '****' + data.phone?.substring(7);
                    }
                }
                delete data.role_ids;
                this.formData = data;
                this.formData.org_id = data.org_id;
                this.switchValue = data.state === 'ENABLE';
            }
            else {
                this.formData = {
                    real_name: '',
                    user_name: '',
                    role_id: '',
                    org_id: '',
                    phone: '',
                    email: '',
                    password: '',
                    check_password: '',
                    assign_devices: [],
                    shared: true,
                };
            }
        });
    }
    beforeDestroy() {
        // 移除监听事件"getuserDetail"
        EventBus.$off('getuserDetail');
    }
    submit() {
        this.$refs.ruleForm.validate(async (valid) => {
            if (valid) {
                let mode = this.$parent.type;
                this.formData.role_ids = [this.formData.role_id];
                if (mode === 'add') {
                    // 添加逻辑
                    addUser(this.formData).then((res) => {
                        this.$message({
                            message: this.$t('addSuccessfully'),
                            type: 'success',
                        });
                        console.log(res);
                        EventBus.$emit('getUserList');
                        EventBus.$emit('getOrgTree');
                        this.handleClose();
                    });
                }
                else if (mode === 'edit') {
                    // 编辑逻辑
                    editUser(this.formData).then((res) => {
                        this.$message({
                            message: this.$t('editSuccessfully'),
                            type: 'success',
                        });
                        console.log(res);
                        EventBus.$emit('getUserList');
                        EventBus.$emit('getOrgTree');
                        this.handleClose();
                    });
                }
            }
            else {
                return false;
            }
        });
    }
    // 共享开关
    sharedSwitch(val) {
        if (val) {
            this.formData.assign_devices = [];
            this.formData.role_id = '';
        }
    }
    // switch开关事件
    userSwitch(switchValue) {
        let params = [this.formData.user_id];
        if (switchValue) {
            enableUsers(params)
                .then(() => {
                this.$message({
                    message: this.$t('openSuccessfully'),
                    type: 'success',
                    customClass: 'zZindex',
                });
                EventBus.$emit('getUserList');
                EventBus.$emit('getOrgTree');
            })
                .catch((err) => {
                this.$message({ message: err, type: 'error' });
            });
        }
        else {
            disableUsers(params)
                .then(() => {
                this.$message({
                    message: this.$t('ClosedSuccessfully'),
                    type: 'success',
                    customClass: 'zZindex',
                });
                EventBus.$emit('getUserList');
                EventBus.$emit('getOrgTree');
            })
                .catch((err) => {
                this.$message({ message: err, type: 'error' });
            });
        }
    }
};
__decorate([
    Prop()
], default_1.prototype, "addDialogVisible", void 0);
__decorate([
    Prop()
], default_1.prototype, "type", void 0);
default_1 = __decorate([
    Component({
        name: 'addModel',
        components: { 'tree-select': treeSelect, deviceSelect },
        i18n: {
            messages: langMsg,
        },
    })
], default_1);
export default default_1;
